/** @format */

const stringTranslations = {
    // ===== Calendar =====

    // Calendar tab for kind of view.
    'View as Calendar': {
        en: 'View as Calendar',
        fr: 'Visualiser sous forme de calendrier',
    },

    // Calendar tab for kind of view.
    'View as List': {
        en: 'View as List',
        fr: 'Visualiser sous forme de liste',
    },

    // Calendar tab kind of date display.
    Day: {
        en: 'Day',
        fr: 'Jour',
    },

    // Calendar tab kind of date display.
    Week: {
        en: 'Week',
        fr: 'Semaine',
    },

    // Calendar tab kind of date display.
    Month: {
        en: 'Month',
        fr: 'Mois',
    },

    // ===== Register =====

    // Creating an account: Prefix - (None).
    '(None)': {
        en: '(None)',
        fr: '(Aucun)',
    },

    'The email address you submitted was invalid. Please try again.': {
        en: 'The email address you submitted was invalid. Please try again.',
        fr: 'L\'adresse courriel que vous avez soumise était invalide. Veuillez réessayer.',
    },

    // ===== Account =====

    // Selec preferences: 'Your changes have been saved'
    'Your changes have been saved': {
        en: 'Your changes have been saved.',
        fr: 'Vos modifications ont été sauvegardées.',
    },

    // ===== Receipt =====
    'Print Your Receipt': {
        en: 'Print your receipt',
        fr: 'Imprimez votre reçu',
    },

    // ===== General =====

    // Any Required text.
    Required: {
        en: 'Required',
        fr: 'Obligatoire',
    },

    'Please Wait': {
        en: 'Please Wait',
        fr: 'Patientez svp',
    },

    'Please wait while we redirect you...': {
        en: 'Please Wait While We Redirect You',
        fr: 'Veuillez patienter pendant que nous vous redirigeons',
    },

    'Do not refresh or leave this page or your order may not be completed.': {
        en: 'Do not refresh or leave this page or your order may not be completed.',
        fr: 'Ne pas actualiser ou quitter cette page autrement votre commande risque de ne pas être complétée.',
    },

    'An unexpected error has occurred.': {
        en: 'An unexpected error has occurred.',
        fr: 'Une erreur inattendue est survenue.',
    },

    'An unknown error has occurred.': {
        en: 'An unknown error has occurred.',
        fr: 'Une erreur inconnue s\'est produite.',
    },

    'There\'s been a system error. Please retry your request.': {
        en: 'There\'s been a system error. Please retry your request.',
        fr: 'Une erreur de système est survenue. Veuillez réessayer votre demande.',
    },

    'Cancel': {
        en: 'Cancel',
        fr: 'Annuler',
    },

    'Submit': {
        en: 'Submit',
        fr: 'Soumettre',
    },

    'Cart': {
        en: 'Cart',
        fr: 'Mon panier',
    },

    'Amount:&nbsp;': {
        en: 'Price:',
        fr: 'Prix :',
    },

    'Tax:': {
        en: 'Tax:',
        fr: 'Taxe :',
    },

    'Account Options': {
        en: 'Account Options',
        fr: 'Options du compte',
    },

    'Account': {
        en: 'Account',
        fr: 'Mon compte',
    },

    // ===== Misc off-screen content =====

    'Required': {
        'en': 'Required',
        'fr': 'Obligatoire'
    },
    'Please correct the following error(s):': {
        'en': 'Please correct the following error(s):',
        'fr': 'Veuillez corriger la ou les erreurs suivantes :'
    },
    'Form Errors': {
        'en': 'Form Errors',
        'fr': 'Erreurs dans le formulaire'
    },
    'Loading': {
        'en': 'Loading',
        'fr': 'Chargement'
    },
    'Loading Failed.': {
        'en': 'Loading Failed.',
        'fr': 'Échec du chargement.'
    },
    'Finished Loading.': {
        'en': 'Finished Loading.',
        'fr': 'Chargement terminé.'
    },
    'There was an error adding your selection to the cart. Please review your quantity and price selections.': {
        'en': 'There was an error adding your selection to the cart. Please review your quantity and price selections.',
        'fr': 'Une erreur s\'est produite lors de l\'ajout de votre sélection au panier. Veuillez vérifier vos sélections de quantité et de prix.'
    },
    // 'Less than ## minutes remaining before your order expires.': {
    //     'en': 'Less than ## minutes remaining before your order expires.',
    //     'fr': 'Il reste moins de ## minutes avant l\'expiration de votre commande.'
    // },
    'Cancel': {
        'en': 'Cancel',
        'fr': 'Annuler'
    },
    'Submit': {
        'en': 'Submit',
        'fr': 'Soumettre'
    },
    'Account': {
        'en': 'Account',
        'fr': 'Compte'
    },
    'Cart': {
        'en': 'Cart',
        'fr': 'Carte'
    },
    'Selection': {
        'en': 'Selection',
        'fr': 'Sélection'
    },
    'Enter promotional code': {
        'en': 'Enter promotional code',
        'fr': 'Saisissez le code promotionnel'
    },
    'Enter Promo Code': {
        'en': 'Enter Promo Code',
        'fr': 'Saisissez le code promotionnel'
    },
    'Account Options': {
        'en': 'Account Options',
        'fr': 'Options du compte'
    },
    'Items': {
        'en': 'Items',
        'fr': 'Articles'
    },
    'Date': {
        'en': 'Date',
        'fr': 'Date'
    },
    'Location': {
        'en': 'Location',
        'fr': 'Emplacement'
    },
    'Name': {
        'en': 'Name',
        'fr': 'Nom'
    },
    'Description': {
        'en': 'Description',
        'fr': 'Description'
    },
    'Type': {
        'en': 'Type',
        'fr': 'Type'
    },
    'Type:': {
        'en': 'Type:',
        'fr': 'Type :'
    },
    'Type:&nbsp;': {
        'en': 'Type:',
        'fr': 'Type :'
    },
    'Price': {
        'en': 'Price',
        'fr': 'Prix'
    },
    'Price:&nbsp;': {
        'en': 'Price',
        'fr': 'Prix'
    },
    'Row': {
        'en': 'Row',
        'fr': 'Rangée'
    },
    'Seat': {
        'en': 'Seat',
        'fr': 'Siège'
    },
    'Cart Total': {
        'en': 'Cart Total',
        'fr': 'Total du panier'
    },
    'Checkout': {
        'en': 'Checkout',
        'fr': 'Caisse'
    },
    'Checkout as a Guest': {
        'en': 'Checkout as a guest',
        'fr': 'Commander en tant que visiteur'
    },
    'Please Wait': {
        'en': 'Please wait',
        'fr': 'Patientez svp'
    },
    'Print Your Receipt': {
        'en': 'Print your receipt',
        'fr': 'Imprimer votre reçu'
    },
    'An unknown error has occurred.': {
        'en': 'An unknown error has occurred.',
        'fr': 'Une erreur inconnue s\'est produite.'
    },
    'Available ticket types:': {
        'en': 'Available ticket types:',
        'fr': 'Types de billets disponibles :'
    },
    'Seat Limit Reached': {
        'en': 'Seat Limit Reached',
        'fr': 'Limite de sièges atteinte'
    },
    // 'You have reached the maximum number of required seats allowed per order (##). If you would like to change seats, please first remove a seat and try again': {
    //     'en': 'You have reached the maximum number of required seats allowed per order (##). If you would like to change seats, please first remove a seat and try again.',
    //     'fr': 'Vous avez atteint le nombre maximum de sièges requis alloués par commande (##). Si vous souhaitez changer de sièges, veuillez d\'abord retirer un siège et réessayer.'
    // },
    'Close': {
        'en': 'Close',
        'fr': 'Fermer'
    },
    'Unable to Reserve Seats': {
        'en': 'Unable to Reserve Seats',
        'fr': 'Impossible de réserver des sièges'
    },
    'The seat(s) selected are not available for purchase or will leave a single seat remaining. Please make another selection.': {
        'en': 'The seat(s) selected are not available for purchase or will leave a single seat remaining. Please make another selection.',
        'fr': 'Le ou les sièges sélectionnés ne sont pas disponibles à l\'achat ou ne laisseront qu\'un seul siège restant. Veuillez effectuer une autre sélection.'
    },
    'Seat availability is being refreshed.': {
        'en': 'Seat availability is being refreshed.',
        'fr': 'La disponibilité des sièges est en cours d\'actualisation.'
    },
    'An Error Has Occurred': {
        'en': 'An Error Has Occurred',
        'fr': 'Une erreur s\'est produite'
    },
    'Please refresh the page to try selecting seats again.': {
        'en': 'Please refresh the page to try selecting seats again.',
        'fr': 'Veuillez actualiser la page pour tenter de sélectionner à nouveau des sièges.'
    },
    'You may also click "Let us choose the best seats for you" link on this page to have the best seats selected for you, or please contact us directly for assistance.': {
        'en': 'You may also click "Let us choose the best seats for you" link on this page to have the best seats selected for you, or please contact us directly for assistance.',
        'fr': 'Vous pouvez également cliquer sur le lien « Laissez-nous choisir les meilleurs sièges pour vous » sur cette page pour que les meilleurs sièges soient sélectionnés pour vous, ou veuillez communiquer directement avec nous pour obtenir de l\'aide.'
    },
    'Choose a Ticket Type': {
        'en': 'Choose a Ticket Type',
        'fr': 'Choisissez un type de billet'
    },
    'Section': {
        'en': 'Section',
        'fr': 'Section'
    },
    'Keyboard Shortcuts': {
        'en': 'Keyboard Shortcuts',
        'fr': 'Essayer les raccourcis clavier'
    },
    'You can use the following keyboard commands to navigate available seats or to adjust the visible portion of the seat map.': {
        'en': 'You can use the following keyboard commands to navigate available seats or to adjust the visible portion of the seat map.',
        'fr': 'Vous pouvez utiliser les commandes clavier suivantes pour naviguer parmi les sièges disponibles ou pour ajuster la partie visible du plan de salle.'
    },
    'Action': {
        'en': 'Action',
        'fr': 'Action'
    },
    'Command': {
        'en': 'Command',
        'fr': 'Commande'
    },
    'Zoom In': {
        'en': 'Zoom In',
        'fr': 'Zoom avant'
    },
    'Zoom Up': {
        'en': 'Zoom Up',
        'fr': 'Zoom vers le haut'
    },
    'Pan Up': {
        'en': 'Pan Up',
        'fr': 'Panoramique vers le haut'
    },
    'Pan Out': {
        'en': 'Pan Out',
        'fr': 'Panoramique arrière'
    },
    'Reset Pan and Zoom': {
        'en': 'Reset Pan and Zoom',
        'fr': 'Réinitialiser le panoramique et le zoom'
    },
    'Navigate Available Seats': {
        'en': 'Navigate Available Seats',
        'fr': 'Naviguer parmi les sièges disponibles'
    },
    'Jump to First Seat In Row': {
        'en': 'Jump to First Seat In Row',
        'fr': 'Passer au premier siège de la rangée'
    },
    'Jump to Last Seat In Row': {
        'en': 'Jump to Last Seat In Row',
        'fr': 'Passer au dernier siège de la rangée'
    },
    'Jump to First Row': {
        'en': 'Jump to First Row',
        'fr': 'Passer à la première rangée'
    },
    'Jump to Last Row': {
        'en': 'Jump to Last Row',
        'fr': 'Passer à la dernière rangée'
    },
    'Jump to First Seat In Section': {
        'en': 'Jump to First Seat In Section',
        'fr': 'Passer au premier siège de la section'
    },
    'Jump to Last Seat In Section': {
        'en': 'Jump to Last Seat In Section',
        'fr': 'Passer au dernier siège de la section'
    },
    'and': {
        'en': 'and',
        'fr': 'et'
    },
    'or': {
        'en': 'or',
        'fr': 'ou'
    },
    'Item Details': {
        'en': 'Item Details',
        'fr': 'Détails de l\'article'
    },
    'Item details': {
        'en': 'Item details',
        'fr': 'Détails de l\'article'
    },
    'Country Restriction Inaccessible Message': {
        'en': 'Country Restriction Inaccessible Message',
        'fr': 'Message d\'inaccessibilité de restriction selon le pays'
    },
    'Country Restriction Account Required Message': {
        'en': 'Country Restriction Account Required Message',
        'fr': 'Message de compte requis de restriction selon le pays'
    },
    'Seat Map': {
        'en': 'Seat Map',
        'fr': 'Plan de salle'
    },
    'Legend': {
        'en': 'Legend',
        'fr': 'Légende'
    },
    'Sections': {
        'en': 'Sections',
        'fr': 'Sections'
    },
    'Seat Type Icons': {
        'en': 'Seat Type Icons',
        'fr': 'Icônes du type de siège'
    },
    'Map Controls': {
        'en': 'Map Controls',
        'fr': 'Contrôles du plan'
    },
    'Seat Information': {
        'en': 'Seat Information',
        'fr': 'Informations sur le siège'
    },
    'Selected Seats': {
        'en': 'Selected Seats',
        'fr': 'Sièges sélectionnés'
    },
    'Seat:': {
        'en': 'Seat:',
        'fr': 'Siège :'
    },
    'Section:': {
        'en': 'Section:',
        'fr': 'Section :'
    },
    'Seat Location: Row:': {
        'en': 'Seat Location: Row:',
        'fr': 'Emplacement du siège : Rangée :'
    },
    'Price:': {
        'en': 'Price:',
        'fr': 'Prix :'
    },
    // 'You have # seat selected for a subtotal of $$$': {
    //     'en': 'You have # seat selected for a subtotal of $$$',
    //     'fr': 'Le nombre de sièges sélectionnés est de # pour un total partiel de $$$.'
    // },
    'Quantity:': {
        'en': 'Quantity:',
        'fr': 'Quantité :'
    },
    'Quantity:&nbsp;': {
        'en': 'Quantity:',
        'fr': 'Quantité :'
    },
    // 'Quantity for {zone name}': {
    //     'en': 'Quantity for {zone name}',
    //     'fr': 'Quantité pour {zone name}'
    // },
    // 'Item # of #': {
    //     'en': 'Item # of #',
    //     'fr': 'Article # de #'
    // },
    // 'Events for Item # of #': {
    //     'en': 'Events for Item # of #',
    //     'fr': 'Événements pour l\'article # de #'
    // },
    // 'Available Sections for Item # of #': {
    //     'en': 'Available Sections for Item # of #',
    //     'fr': 'Sections disponibles pour l\'article # de #'
    // },
    'Venue': {
        'en': 'Venue',
        'fr': 'Lieu'
    },
    'Events': {
        'en': 'Events',
        'fr': 'Événements'
    },
    "Additional Options": {
        'en': 'Additional Options',
        'fr': 'Options supplémentaires'
    },
    'Package Item Options': {
        'en': 'Combo Item Options',
        'fr': 'Options de forfaits et d\'articles'
    },
    'Location': {
        'en': 'Location',
        'fr': 'Emplacement'
    },
    'Date Range': {
        'en': 'Date Range',
        'fr': 'Fourchette de dates'
    },
    'Instructions': {
        'en': 'Instructions',
        'fr': 'Instructions'
    },
    'Required Groups': {
        'en': 'Required Tickets',
        'fr': 'Billets requis'
    },
    'Title': {
        'en': 'Title',
        'fr': 'Titre'
    },
    'Start this package over': {
        'en': 'Start this combo over',
        'fr': 'Recommencer ce forfait'
    },
    'Please wait while we redirect you': {
        'en': 'Please Wait While We Redirect You',
        'fr': 'Veuillez patienter pendant que nous vous redirigeons'
    },
    'Do not refresh or leave this page or your order may not be completed.': {
        'en': 'Do not refresh or leave this page or your order may not be completed.',
        'fr': 'Ne pas actualiser ou quitter cette page autrement votre commande risque de ne pas être complétée.'
    },
    'An unknown error has occured.': {
        'en': 'An unknown error has occurred.',
        'fr': 'Une erreur inconnue s\'est produite.'
    },
    'Try Keyboard Shortcuts': {
        'en': 'Try Keyboard Shortcuts',
        'fr': 'Essayer les raccourcis clavier'
    },
    'Navigate by Day': {
        'en': 'Navigate by Day',
        'fr': 'Naviguer par jour'
    },
    'Navigate by Month': {
        'en': 'Navigate by Month',
        'fr': 'Naviguer par mois'
    },
    'Navigate by Year': {
        'en': 'Navigate by Year',
        'fr': 'Naviguer par année'
    },
    'Sunday': {
        'en': 'Sunday',
        'fr': 'dimanche'
    },
    'Monday': {
        'en': 'Monday',
        'fr': 'lundi'
    },
    'Tuesday': {
        'en': 'Tuesday',
        'fr': 'mardi'
    },
    'Wednesday': {
        'en': 'Wednesday',
        'fr': 'mercredi'
    },
    'Thursday': {
        'en': 'Thursday',
        'fr': 'jeudi'
    },
    'Friday': {
        'en': 'Friday',
        'fr': 'vendredi'
    },
    'Saturday': {
        'en': 'Saturday',
        'fr': 'samedi'
    },
    'January': {
        'en': 'January',
        'fr': 'janvier'
    },
    'February': {
        'en': 'February',
        'fr': 'février'
    },
    'March': {
        'en': 'March',
        'fr': 'mars'
    },
    'April': {
        'en': 'April',
        'fr': 'avril'
    },
    'May': {
        'en': 'May',
        'fr': 'mai'
    },
    'June': {
        'en': 'June',
        'fr': 'juin'
    },
    'July': {
        'en': 'July',
        'fr': 'juillet'
    },
    'August': {
        'en': 'August',
        'fr': 'août'
    },
    'September': {
        'en': 'September',
        'fr': 'septembre'
    },
    'October': {
        'en': 'October',
        'fr': 'octobre'
    },
    'November': {
        'en': 'November',
        'fr': 'novembre'
    },
    'December': {
        'en': 'December',
        'fr': 'décembre'
    },
    'Jan': {
        'en': 'Jan',
        'fr': 'janv'
    },
    'Feb': {
        'en': 'Feb',
        'fr': 'févr'
    },
    'Mar': {
        'en': 'Mar',
        'fr': 'mars'
    },
    'Apr': {
        'en': 'Apr',
        'fr': 'avr'
    },
    'May': {
        'en': 'May',
        'fr': 'mai'
    },
    'Jun': {
        'en': 'Jun',
        'fr': 'juin'
    },
    'Jul': {
        'en': 'Jul',
        'fr': 'juill'
    },
    'Aug': {
        'en': 'Aug',
        'fr': 'août'
    },
    'Sep': {
        'en': 'Sep',
        'fr': 'sept'
    },
    'Oct': {
        'en': 'Oct',
        'fr': 'oct'
    },
    'Nov': {
        'en': 'Nov',
        'fr': 'nov'
    },
    'Dec': {
        'en': 'Dec',
        'fr': 'déc'
    },
    'Change the way events are displayed': {
        'en': 'Change the way events are displayed',
        'fr': 'Modifier l\'affichage des événements'
    },
    'Calendar View': {
        'en': 'Calendar View',
        'fr': 'Affichage en mode calendrier'
    },
    'List View': {
        'en': 'List View',
        'fr': 'Affichage en mode liste'
    },
    'Retrieving Events': {
        'en': 'Retrieving Events',
        'fr': 'Récupération d\'événements'
    },
    'Events Retrieved': {
        'en': 'Events Retrieved',
        'fr': 'Événements récupérés'
    },
    'Display calendar by:': {
        'en': 'Display calendar by:',
        'fr': 'Affichage du calendrier par :'
    },
    'Select Month': {
        'en': 'Select Month',
        'fr': 'Sélectionner le mois'
    },
    'Select Week': {
        'en': 'Select Week',
        'fr': 'Sélectionner la semaine'
    },
    'Select Day': {
        'en': 'Select Day',
        'fr': 'Sélectionner le jour'
    },
    'Previous': {
        'en': 'Previous',
        'fr': 'Précédent'
    },
    'Next': {
        'en': 'Next',
        'fr': 'Suivant'
    },
    'Select start date': {
        'en': 'Select start date',
        'fr': 'Sélectionner une date de début'
    },
    'Select end date': {
        'en': 'Select end date',
        'fr': 'Sélectionner une date de fin'
    },
    'Amount:': {
        'en': 'Amount:',
        'fr': 'Prix :'
    },
    'Package List': {
        'en': 'Combo List',
        'fr': 'Liste de forfaits'
    },
    'Date Range:': {
        'en': 'Date Range:',
        'fr': 'Fourchette de dates :'
    },
    'Location:': {
        'en': 'Location:',
        'fr': 'Emplacement :'
    },
    'Description:': {
        'en': 'Description:',
        'fr': 'Description :'
    },
    'Go to selected item': {
        'en': 'Go to selected item',
        'fr': 'Accéder à l\'article sélectionné'
    },
    'There was a problem accessing your ticket(s). Please try again or contact us for assistance.': {
        'en': 'There was a problem accessing your ticket(s). Please try again or contact us for assistance.',
        'fr': 'Un problème est survenu lors de l\'accès à votre ou vos billets. Veuillez réessayer ou communiquer avec nous pour obtenir de l\'aide.'
    },
    'There\'s been a system error. Please retry your request.': {
        'en': 'There\'s been a system error. Please retry your request.',
        'fr': 'Une erreur de système est survenue. Veuillez réessayer votre demande.'
    },
    // 'Packages for Order #….': {
    //     'en': 'Combos for Order #….',
    //     'fr': 'Forfaits pour la commande #....'
    // },
    'Name:': {
        'en': 'Name:',
        'fr': 'Nom :'
    },
    'Name:&nbsp;': {
        'en': 'Name:',
        'fr': 'Nom :'
    },
    // 'Items for Package for Order #…': {
    //     'en': 'Items for Ticket Combo for Order #…',
    //     'fr': 'Articles pour le forfait de billets pour la commande #...'
    // },
    // 'Seat ##, Select ## of ##': {
    //     'en': 'Seat ##, Select ## of ##',
    //     'fr': 'Siège ##, Sélection ## de ##'
    // },
    'Order Contents': {
        'en': 'Your Order',
        'fr': 'Votre commande'
    },

    // Modal close button.
    Close: {
        en: 'Close',
        fr: 'Fermer',
    },

    'Hide instructions': {
        en: 'Show instructions',
        fr: 'Montrer les instructions',
    },

    'Show instructions': {
        en: 'Hide instructions',
        fr: 'Cacher les instructions',
    },

    'Cacher les instructions': {
        en: 'Show instructions',
        fr: 'Montrer les instructions',
    },

    'Montrer les instructions': {
        en: 'Hide instructions',
        fr: 'Cacher les instructions',
    },

    // ===== Dynamic buttons =====

    'Today and tomorrow': {
        en: 'Today and tomorrow',
        fr: 'Aujourd\'hui et demain',
    },

    'This week': {
        en: 'This week',
        fr: 'Cette semaine',
    },

    'All options': {
        en: 'All options',
        fr: 'Toutes les options',
    },

    'Next 30 days': {
        en: 'Next 30 days',
        fr: '30 prochains jours',
    },

    'Previous day': {
        en: 'Previous day',
        fr: 'Jour précédent',
    },

    'Next day': {
        en: 'Next day',
        fr: 'Jour suivant',
    },

    'Previous week': {
        en: 'Previous week',
        fr: 'Semaine précédente',
    },

    'Next week': {
        en: 'Next week',
        fr: 'Semaine suivante',
    },

    'Previous month': {
        en: 'Previous month',
        fr: 'Mois précédent',
    },

    'Next month': {
        en: 'Next month',
        fr: 'Mois suivant',
    },

    // ===== Tickets for title =====

    'Tickets for:': {
        en: 'Tickets for:',
        fr: 'Billets pour:',
    },

    // Performance aliases
    'The Man Who Planted Trees': {
        en: 'The Man Who Planted Trees',
        fr: '« L\'homme qui plantait des arbres »'
    },
    'Butterflies in Flight': {
        en: 'Butterflies in Flight',
        fr: '« Papillons en vol »'
    },
    'General Admission': {
        en: 'General Admission',
        fr: 'Droits d\'entrée'
    },
    'The Man Who Planted Trees : les options n\'ont pas encore été sélectionnées': {
        en: 'The Man Who Planted Trees options not yet selected',
        fr: '« L\'homme qui plantait des arbres » : les options n\'ont pas encore été sélectionnées'
    },
    'Butterflies in Flight : les options n\'ont pas encore été sélectionnées': {
        en: 'Butterflies in Flight options not yet selected',
        fr: '« Papillons en vol » : les options n\'ont pas encore été sélectionnées'
    },
    'General Admission : les options n\'ont pas encore été sélectionnées': {
        en: 'General Admission options not yet selected',
        fr: 'Droits d\'entrée : les options n\'ont pas encore été sélectionnées'
    },

    // Form labels
    'Remove': {
        en: 'Remove',
        fr: 'Effacer'
    },
    'Remove Item': {
        en: 'Remove Item',
        fr: 'Retirer l\'article',
    },
    'Choose from Available Items': {
        en: 'Choose from Available Items',
        fr: 'Choisissez parmi les articles disponibles',
    },
    'Opens in a New Window': {
        en: 'Opens in a New Window',
        fr: 'S\'ouvre dans une nouvelle fenêtre',
    },
    'Opens in a new Window': {
        en: 'Opens in a new Window',
        fr: 'S\'ouvre dans une nouvelle fenêtre',
    },

};

const stringOnCalendar = {
    // Translations for the calendar picker letter that says the day of the week.
    0: {
        en: 'S',
        fr: 'D',
    },

    1: {
        en: 'M',
        fr: 'L',
    },

    2: {
        en: 'T',
        fr: 'M',
    },

    3: {
        en: 'W',
        fr: 'M',
    },

    4: {
        en: 'T',
        fr: 'J',
    },

    5: {
        en: 'F',
        fr: 'V',
    },

    6: {
        en: 'S',
        fr: 'S',
    },
}

const priceLabelTranslations = {
    // Translations for the Price labels
    '*Memb Adult/Adulte': {
        en: 'Member Adult',
        fr: 'Membre adulte',
    },
    '*Memb Senior/Aîné': {
        en: 'Member Senior (65+)',
        fr: 'Membre aîné (65+)',
    },
    '*Memb Tiny Tot/Tout-petit': {
        en: 'Member Tiny Tot (0–2)',
        fr: 'Membre tout-petit (0 à 2)',
    },
    '*Memb Child/Enfant': {
        en: 'Member Child (3–12)',
        fr: 'Membre enfant (3 à 12)',
    },
    '*Memb Student 13+/Étudiant 13+': {
        en: 'Member Student (13+)',
        fr: 'Membre étudiant (13+)',
    },
    '*Memb Student 18+/Étudiant 18+': {
        en: 'Member Student (18+)',
        fr: 'Membre étudiant (18+)',
    },
    '*Adult/Adulte 18–24': {
        en: 'Adult (18–24)',
        fr: 'Adulte (18 à 24)'
    },
    '*Adult/Adulte 25–64': {
        en: 'Adult (25–64)',
        fr: 'Adulte (25 à 64)'
    },
    '*Adult/Adulte': {
        en: 'Adult',
        fr: 'Adulte',
    },
    '*Senior/Aîné': {
        en: 'Senior (65+)',
        fr: 'Aîné (65+)',
    },
    '*Tiny Tot/Tout-petit': {
        en: 'Tiny Tot (0–2)',
        fr: 'Tout-petit (0 à 2)',
    },
    '*Child/Enfant': {
        en: 'Child (3–12)',
        fr: 'Enfant (3 à 12)',
    },
    '*Student 13+/Étudiant 13+': {
        en: 'Student (13+)',
        fr: 'Étudiant (13+)',
    },
    '*Student 18+/Étudiant 18+': {
        en: 'Student (18+)',
        fr: 'Étudiant (18+)',
    },
    '*Postdoctoral': {
        en: 'Post-Doc',
        fr: 'Universitaire postdoctoral',
    },
    '*Staff-Volunteer/Employe-Benev': {
        en: 'Staff/Volunteer',
        fr: 'Employé/Bénévole',
    },
    '*DiscountedAdult/Rabais adulte': {
        en: 'Discounted Adult',
        fr: 'Rabais adulte',
    },
    '*Memb Pkg Adult/Adulte': {
        en: 'Member Adult',
        fr: 'Membre adulte',
    },
    '*Memb Pkg Senior/Aîné': {
        en: 'Member Senior (65+)',
        fr: 'Membre aîné (65+)',
    },
    '*Memb Pkg Tiny Tot/Tout-petit': {
        en: 'Member Tiny Tot (0–2)',
        fr: 'Membre tout-petit (0 à 2)',
    },
    '*Memb Pkg Child/Enfant': {
        en: 'Member Child (3–12)',
        fr: 'Membre enfant (3 à 12)',
    },
    '*Memb Pkg Student 13+/Étud 13+': {
        en: 'Member Student (13+)',
        fr: 'Membre étudiant (13+)',
    },
    '*Memb Pkg Stu 18+/Étud 18+': {
        en: 'Member Student (18+)',
        fr: 'Membre étudiant (18+)',
    },
    '*Pkg Adult/Adulte 18–24': {
        en: 'Adult (18–24)',
        fr: 'Adulte (18 à 24)'
    },
    '*Pkg Adult/Adulte 25–64': {
        en: 'Adult (25–64)',
        fr: 'Adulte (25 à 64)'
    },
    '*Pkg Adult/Adulte': {
        en: 'Adult',
        fr: 'Adulte',
    },
    '*Pkg Senior/Aîné': {
        en: 'Senior (65+)',
        fr: 'Aîné (65+)',
    },
    '*Pkg Tiny Tot/Tout-petit': {
        en: 'Tiny Tot (0–2)',
        fr: 'Tout-petit (0 à 2)',
    },
    '*Pkg Child/Enfant': {
        en: 'Child (3–12)',
        fr: 'Enfant (3 à 12)',
    },
    '*Pkg Student 13+/Étudiant 13+': {
        en: 'Student (13+)',
        fr: 'Étudiant (13+)',
    },
    '*Pkg Student 18+/Étudiant 18+': {
        en: 'Student (18+)',
        fr: 'Étudiant (18+)',
    },
    '*Pkg2 Adult/Adulte': {
        en: 'Adult',
        fr: 'Adulte',
    },
    '*Pkg2 Senior/Aîné': {
        en: 'Senior (65+)',
        fr: 'Aîné (65+)',
    },
    '*Pkg2 Tiny Tot/Tout-petit': {
        en: 'Tiny Tot (0–2)',
        fr: 'Tout-petit (0 à 2)',
    },
    '*Pkg2 Child/Enfant': {
        en: 'Child (3–12)',
        fr: 'Enfant (3 à 12)',
    },
    '*Pkg2 Student 13+/Étudiant 13+': {
        en: 'Student (13+)',
        fr: 'Étudiant (13+)',
    },
    '*Pkg2 Student 18+/Étudiant 18+': {
        en: 'Student (18+)',
        fr: 'Étudiant (18+)',
    },
    '*Comp Adult/Adulte grac.': {
        en: 'Complimentary Adult',
        fr: 'Gratuit adulte',
    },
    '*Comp Senior/Aîné grac.': {
        en: 'Complimentary Senior (65+)',
        fr: 'Gratuit aîné (65+)',
    },
    '*Comp TinyTot/Tout-petit grac.': {
        en: 'Complimentary Tiny Tot (0–2)',
        fr: 'Gratuit tout-petit (0 à 2)',
    },
    '*Comp Child/Enfant grac.': {
        en: 'Complimentary Child (3–12)',
        fr: 'Gratuit enfant (3 à 12)',
    },
    '*Comp Stu 13+/Étud 13+ grac.': {
        en: 'Complimentary Student (13+)',
        fr: 'Gratuit étudiant (13+)',
    },
    '*Comp Stu 18+/Étud 18+ grac.': {
        en: 'Complimentary Student (18+)',
        fr: 'Gratuit étudiant (18+)',
    },
    '*Youth/Jeune': {
        en: 'Youth (13–17)',
        fr: 'Jeune (13 à 17)'
    },
    '*Pkg Youth/Jeune': {
        en: 'Youth (13–17)',
        fr: 'Jeune (13 à 17)'
    }
}

const membershipTranslations = {
    'Family Membership | Adhésion familiale': {
        en: 'Family Membership',
        fr: 'Adhésion familiale',
    },
    'Family Membership + Plus One | Adhésion familiale + plus-un': {
        en: 'Family Membership with Plus One',
        fr: 'Adhésion familiale avec option plus-un'
    },
    'Family Membership + 20% Off | Adhésion familiale + réduction de 20 %': {
        en: 'Family Membership with 20% Off',
        fr: 'Adhésion familiale avec réduction de 20 %'
    },
    'Family Membership + 20% Off + Plus One | Adhésion familiale + réduction de 20 % + plus-un': {
        en: 'Family Membership with 20% Off and Plus One',
        fr: 'Adhésion familiale avec réduction de 20 % et option plus-un'
    },
    'Individual Membership | Adhésion individuelle': {
        en: 'Individual Membership',
        fr: 'Adhésion individuelle'
    },
    'Individual Membership + Plus One | Adhésion individuelle + plus-un': {
        en: 'Individual Membership with Plus One',
        fr: 'Adhésion individuelle avec option plus-un'
    },
    'Individual Membership + 20% Off | Adhésion individuelle + réduction de 20 %': {
        en: 'Individual Membership with 20% Off',
        fr: 'Adhésion individuelle avec réduction de 20 %'
    },
    'Individual Membership + 20% Off + Plus One | Adhésion individuelle + réduction de 20 % + plus-un': {
        en: 'Individual Membership with 20% Off and Plus One',
        fr: 'Adhésion individuelle avec réduction de 20 % et option plus-un'
    },
    'Daycare Membership | Adhésion pour garderie': {
        en: 'Daycare Membership',
        fr: 'Adhésion pour garderie'
    },
    'Daycare Membership + Plus One | Adhésion pour garderie + plus-un': {
        en: 'Daycare Membership with Plus One',
        fr: 'Adhésion pour garderie avec option plus-un'
    },
    'Daycare Membership + 20% Off | Adhésion pour garderie + réduction de 20 %': {
        en: 'Daycare Membership with 20% Off',
        fr: 'Adhésion pour garderie avec réduction de 20 %'
    },
    'Daycare Membership + 20% Off + Plus One | Adhésion pour garderie + réduction de 20 % + plus-un': {
        en: 'Daycare Membership with 20% Off and Plus One',
        fr: 'Adhésion pour garderie avec réduction de 20 % et option plus-un'
    },
    'Family Membership for CAA/BCAA/AMA Members | Adhésion familiale pour les membres CAA/BCAA/AMA': {
        en: 'Family Membership for CAA/BCAA/AMA Members',
        fr: 'Adhésion familiale pour les membres CAA/BCAA/AMA'
    },
    'Family Membership + 15% Off + Plus One | Adhésion familiale + réduction de 15 % + plus-un': {
        en: 'Family Membership with Plus One for CAA/BCAA/AMA Members',
        fr: 'Adhésion familiale pour les membres CAA/BCAA/AMA avec option plus-un'
    },
    'Individual Membership for CAA/BCAA/AMA Members | Adhésion individuelle pour les membres CAA/BCAA/AMA': {
        en: 'Individual Membership for CAA/BCAA/AMA Members',
        fr: 'Adhésion individuelle pour les membres CAA/BCAA/AMA'
    },
    'Individual Membership + 15% Off + Plus One | Adhésion individuelle + réduction de 15 % + plus-un': {
        en: 'Individual Membership with Plus One for CAA/BCAA/AMA Members',
        fr: 'Adhésion individuelle pour les membres CAA/BCAA/AMA avec option plus-un'
    }
}

// Interest options with custom copy stored as follows: ID: {en: '', fr: ''}
const accountInterestsTranslations = {
    // Initial label: Sign me up | Abonnez moi
    23: {
        en: "I would like to receive news about special events, offers and what's happening",
        fr: "Je désire recevoir des nouvelles concernant les événements spéciaux, les offres et ce qui se passe"
    },
    // Initial label: Subscribe | S'inscrire
    53: {
        en: "I would like to receive news about programs, products and events for educators",
        fr: "Je désire recevoir des informations sur les programmes, produits et événements destinés aux éducateurs"
    },
    // Initial label: Marketing | Promotion
    54: {
        en: "I would like to receive news about Nature Nocturne",
        fr: "J'aimerais recevoir des nouvelles au sujet de Nature Nocturne",
    },
    // Initial label: Positions | Postes
    65: {
        en: "I would like to receive alerts when new positions at the museum become available",
        fr: "Je désire recevoir une alerte lorsque de nouveaux postes au Musée sont disponibles",
    }
}

export { stringTranslations, stringOnCalendar, priceLabelTranslations, membershipTranslations, accountInterestsTranslations };
